import React from "react";
import { PendingIcon } from "../../Icons";
import CommonButton from "../../Buttons/CommonButton";

const KYCRequiredCard = ({ handleKYCRedirection, requirements }) => {
  let message = "Your account is incomplete. Please perform verification.";
  let buttonText = "Perform Verification";

  switch (true) {
    case !requirements:
      break;

    case requirements.questionnaire:
      message = "Please update your questionnaire details securely.";
      buttonText = "Update Details";
      break;

    case requirements.passport && requirements.selfie:
      message =
        "Please provide your passport and a live selfie for identity verification.";
      buttonText = "Complete Verification";
      break;

    case requirements.passport:
      message =
        "Please provide a clear copy of your passport for verification.";
      buttonText = "Upload Passport";
      break;

    case requirements.selfie:
      message = "Your account is incomplete. Please perform a liveness check.";
      buttonText = "Perform Liveness Check";
      break;

    default:
      break;
  }
  return (
    <div className="bg-gradient-primarycard shadow-lg px-4 py-12 rounded-3xl max-w-lg w-full">
      <div
        className={`text-3xl md:text-4xl font-bold mb-4 flex flex-col items-center justify-center text-center text-primary-600`}
      >
        <PendingIcon className="w-28 h-28 my-4" />
        <h3>Action Required</h3>
      </div>
      <p className="text-lg text-text-primary md:text-xl text-center">
        {message}
      </p>
      <div className="mt-6 flex justify-center">
        <CommonButton onClick={handleKYCRedirection}>{buttonText}</CommonButton>
      </div>
    </div>
  );
};

export default KYCRequiredCard;
